export default __webpack_public_path__ + "static/media/bondly-eth.93147581.svg";